import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface OrbitingCirclesProps extends React.HTMLAttributes<HTMLDivElement> {
	className?: string;
	children?: React.ReactNode;
	reverse?: boolean;
	duration?: number;
	delay?: number;
	radius?: number;
	path?: boolean;
	iconSize?: number;
	speed?: number;
}

export function OrbitingCircles({ className, children, reverse, duration = 20, radius = 160, path = true, iconSize = 30, speed = 1, ...props }: OrbitingCirclesProps) {
	const calculatedDuration = duration / speed;
	return (
		<>
			{path && (
				<svg xmlns='http://www.w3.org/2000/svg' version='1.1' className='pointer-events-none absolute inset-0 size-full'>
					<circle className='' cx='50%' cy='50%' r={radius} fill='none' />
				</svg>
			)}
			{React.Children.map(children, (child, index) => {
				const angle = (360 / React.Children.count(children)) * index;

				const offset = `${angle}deg`;
				const radiusPx = `${radius}px`;
				return (
					<div
						style={
							{
								'--duration': calculatedDuration,
								'--delay': props.delay,
								'--offset': offset,
								'--radius': radiusPx,
								'--icon-size': `${iconSize}px`,
							} as React.CSSProperties
						}
						className={twMerge(
							`absolute flex size-[var(--icon-size)] transform-gpu animate-orbit items-center justify-center ![animation-delay:calc(var(--delay)*1000ms)] rounded-full${reverse ? ' orbiting-element-reverse' : ' orbiting-element'}`,
							className
						)}
						{...props}>
						{child}
					</div>
				);
			})}
		</>
	);
}
